var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7973 20C12.7973 15.7459 16.2459 12.2973 20.5 12.2973C24.7541 12.2973 28.2027 15.7459 28.2027 20C28.2027 24.2541 24.7541 27.7027 20.5 27.7027C16.2459 27.7027 12.7973 24.2541 12.7973 20ZM20.5 25C17.7386 25 15.5 22.7614 15.5 20C15.5 17.2386 17.7386 15 20.5 15C23.2614 15 25.5 17.2386 25.5 20C25.5 22.7614 23.2614 25 20.5 25Z",
    fill: "url(#paint0_linear_443_46882)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7973 20C12.7973 15.7459 16.2459 12.2973 20.5 12.2973C24.7541 12.2973 28.2027 15.7459 28.2027 20C28.2027 24.2541 24.7541 27.7027 20.5 27.7027C16.2459 27.7027 12.7973 24.2541 12.7973 20ZM20.5 25C17.7386 25 15.5 22.7614 15.5 20C15.5 17.2386 17.7386 15 20.5 15C23.2614 15 25.5 17.2386 25.5 20C25.5 22.7614 23.2614 25 20.5 25Z",
    fill: "url(#paint1_radial_443_46882)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.507 13.793C29.5011 13.793 30.3071 12.9871 30.3071 11.993C30.3071 10.9989 29.5011 10.1929 28.507 10.1929C27.513 10.1929 26.707 10.9989 26.707 11.993C26.707 12.9871 27.513 13.793 28.507 13.793Z",
    fill: "url(#paint2_linear_443_46882)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.507 13.793C29.5011 13.793 30.3071 12.9871 30.3071 11.993C30.3071 10.9989 29.5011 10.1929 28.507 10.1929C27.513 10.1929 26.707 10.9989 26.707 11.993C26.707 12.9871 27.513 13.793 28.507 13.793Z",
    fill: "url(#paint3_radial_443_46882)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5C16.4262 5 15.9154 5.01727 14.3155 5.09027C12.7189 5.16309 11.6285 5.41668 10.6744 5.78751C9.68805 6.17079 8.85153 6.68369 8.01758 7.51758C7.18369 8.35153 6.67079 9.18805 6.28751 10.1744C5.91668 11.1285 5.66309 12.2189 5.59027 13.8155C5.51727 15.4154 5.5 15.9262 5.5 20C5.5 24.0738 5.51727 24.5846 5.59027 26.1845C5.66309 27.7811 5.91668 28.8715 6.28751 29.8256C6.67079 30.812 7.18369 31.6485 8.01758 32.4824C8.85153 33.3163 9.68805 33.8292 10.6744 34.2126C11.6285 34.5833 12.7189 34.8369 14.3155 34.9097C15.9154 34.9827 16.4262 35 20.5 35C24.5738 35 25.0846 34.9827 26.6845 34.9097C28.2811 34.8369 29.3715 34.5833 30.3256 34.2126C31.312 33.8292 32.1485 33.3163 32.9824 32.4824C33.8163 31.6485 34.3292 30.812 34.7126 29.8256C35.0833 28.8715 35.3369 27.7811 35.4097 26.1845C35.4827 24.5846 35.5 24.0738 35.5 20C35.5 15.9262 35.4827 15.4154 35.4097 13.8155C35.3369 12.2189 35.0833 11.1285 34.7126 10.1744C34.3292 9.18805 33.8163 8.35153 32.9824 7.51758C32.1485 6.68369 31.312 6.17079 30.3256 5.78751C29.3715 5.41668 28.2811 5.16309 26.6845 5.09027C25.0846 5.01727 24.5738 5 20.5 5ZM20.5 7.7027C24.5052 7.7027 24.9796 7.718 26.5613 7.79017C28.0238 7.85685 28.818 8.10122 29.3466 8.30664C30.0467 8.57875 30.5464 8.90379 31.0713 9.42872C31.5962 9.95359 31.9213 10.4533 32.1934 11.1534C32.3988 11.682 32.6432 12.4762 32.7098 13.9387C32.782 15.5204 32.7973 15.9948 32.7973 20C32.7973 24.0052 32.782 24.4796 32.7098 26.0613C32.6432 27.5238 32.3988 28.318 32.1934 28.8466C31.9213 29.5467 31.5962 30.0464 31.0713 30.5713C30.5464 31.0962 30.0467 31.4213 29.3466 31.6934C28.818 31.8988 28.0238 32.1431 26.5613 32.2098C24.9798 32.282 24.5055 32.2973 20.5 32.2973C16.4945 32.2973 16.0202 32.282 14.4387 32.2098C12.9762 32.1431 12.182 31.8988 11.6534 31.6934C10.9533 31.4213 10.4536 31.0962 9.92872 30.5713C9.40385 30.0464 9.07875 29.5467 8.80664 28.8466C8.60122 28.318 8.35686 27.5238 8.29017 26.0613C8.218 24.4796 8.2027 24.0052 8.2027 20C8.2027 15.9948 8.218 15.5204 8.29017 13.9387C8.35686 12.4762 8.60122 11.682 8.80664 11.1534C9.07875 10.4533 9.40379 9.95359 9.92872 9.42872C10.4536 8.90379 10.9533 8.57875 11.6534 8.30664C12.182 8.10122 12.9762 7.85685 14.4387 7.79017C16.0204 7.718 16.4948 7.7027 20.5 7.7027Z",
    fill: "url(#paint4_linear_443_46882)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5C16.4262 5 15.9154 5.01727 14.3155 5.09027C12.7189 5.16309 11.6285 5.41668 10.6744 5.78751C9.68805 6.17079 8.85153 6.68369 8.01758 7.51758C7.18369 8.35153 6.67079 9.18805 6.28751 10.1744C5.91668 11.1285 5.66309 12.2189 5.59027 13.8155C5.51727 15.4154 5.5 15.9262 5.5 20C5.5 24.0738 5.51727 24.5846 5.59027 26.1845C5.66309 27.7811 5.91668 28.8715 6.28751 29.8256C6.67079 30.812 7.18369 31.6485 8.01758 32.4824C8.85153 33.3163 9.68805 33.8292 10.6744 34.2126C11.6285 34.5833 12.7189 34.8369 14.3155 34.9097C15.9154 34.9827 16.4262 35 20.5 35C24.5738 35 25.0846 34.9827 26.6845 34.9097C28.2811 34.8369 29.3715 34.5833 30.3256 34.2126C31.312 33.8292 32.1485 33.3163 32.9824 32.4824C33.8163 31.6485 34.3292 30.812 34.7126 29.8256C35.0833 28.8715 35.3369 27.7811 35.4097 26.1845C35.4827 24.5846 35.5 24.0738 35.5 20C35.5 15.9262 35.4827 15.4154 35.4097 13.8155C35.3369 12.2189 35.0833 11.1285 34.7126 10.1744C34.3292 9.18805 33.8163 8.35153 32.9824 7.51758C32.1485 6.68369 31.312 6.17079 30.3256 5.78751C29.3715 5.41668 28.2811 5.16309 26.6845 5.09027C25.0846 5.01727 24.5738 5 20.5 5ZM20.5 7.7027C24.5052 7.7027 24.9796 7.718 26.5613 7.79017C28.0238 7.85685 28.818 8.10122 29.3466 8.30664C30.0467 8.57875 30.5464 8.90379 31.0713 9.42872C31.5962 9.95359 31.9213 10.4533 32.1934 11.1534C32.3988 11.682 32.6432 12.4762 32.7098 13.9387C32.782 15.5204 32.7973 15.9948 32.7973 20C32.7973 24.0052 32.782 24.4796 32.7098 26.0613C32.6432 27.5238 32.3988 28.318 32.1934 28.8466C31.9213 29.5467 31.5962 30.0464 31.0713 30.5713C30.5464 31.0962 30.0467 31.4213 29.3466 31.6934C28.818 31.8988 28.0238 32.1431 26.5613 32.2098C24.9798 32.282 24.5055 32.2973 20.5 32.2973C16.4945 32.2973 16.0202 32.282 14.4387 32.2098C12.9762 32.1431 12.182 31.8988 11.6534 31.6934C10.9533 31.4213 10.4536 31.0962 9.92872 30.5713C9.40385 30.0464 9.07875 29.5467 8.80664 28.8466C8.60122 28.318 8.35686 27.5238 8.29017 26.0613C8.218 24.4796 8.2027 24.0052 8.2027 20C8.2027 15.9948 8.218 15.5204 8.29017 13.9387C8.35686 12.4762 8.60122 11.682 8.80664 11.1534C9.07875 10.4533 9.40379 9.95359 9.92872 9.42872C10.4536 8.90379 10.9533 8.57875 11.6534 8.30664C12.182 8.10122 12.9762 7.85685 14.4387 7.79017C16.0204 7.718 16.4948 7.7027 20.5 7.7027Z",
    fill: "url(#paint5_radial_443_46882)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_46882",
    x1: 7.2504,
    y1: 6.57719,
    x2: 16.7091,
    y2: 43.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_443_46882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5823 35) rotate(32.1601) scale(28.0184 20.1639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_443_46882",
    x1: 7.2504,
    y1: 6.57719,
    x2: 16.7091,
    y2: 43.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_443_46882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5823 35) rotate(32.1601) scale(28.0184 20.1639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_443_46882",
    x1: 7.2504,
    y1: 6.57719,
    x2: 16.7091,
    y2: 43.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_443_46882",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5823 35) rotate(32.1601) scale(28.0184 20.1639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsta);
export default __webpack_public_path__ + "static/media/iconInsta.bb82677e2c717f5ddc4c4b86be2821db.svg";
export { ForwardRef as ReactComponent };